import {httpClient} from '../baseApi';

export async function requestWorkloadData(machineId: string, startDate: number, endDate: number) {
  const {data} = await httpClient.get(`services/workload/get_data/`, {
    params: {
      machine_id: machineId,
      start_date: startDate,
      end_date: endDate,
    },
  });

  const intervalsModes = data.machine_status_events.map((elem: any) => ({
    start: elem.start,
    end: elem.end,
    mode: elem.unstatus,
  }));

  return {
    intervalsModes,
  };
}

export async function exportReport(
  machineId: string,
  startDate: number,
  endDate: number,
  reportFileName: string,
  keyFilename: string,
) {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const response = await httpClient.post(`services/workload/export_report/`, null, {
    params: {
      machine_id: machineId,
      start_date: startDate,
      end_date: endDate,
      report_filename: reportFileName,
      key_filename: keyFilename,
      timezone_name: timezone,
    },
  });

  return response;
}
